import { useMutation } from '@tanstack/react-query'

import axiosInstance from '@/libs/configs/axios'

export type TNotificationChannel = 'email' | 'push'

export type TNotificationEngagementPayload = {
  subSurveyId: string
  channel: TNotificationChannel
}

async function postNotificationEngagementAPI({
  subSurveyId,
  channel,
}: TNotificationEngagementPayload) {
  const result = await axiosInstance({
    baseURL: process.env.NEXT_PUBLIC_API_URL,
    url: '/survey/user/surveys/notification-engagement',
    method: 'post',
    data: { subSurveyId, channel },
  })

  return result?.data
}

/**
 * Records that the user reached the app by clicking a survey notification.
 *
 * Fire-and-forget telemetry: the backend keeps only the first touch per channel, so a duplicate
 * call is harmless, and a failure must stay invisible to the user — hence the swallowed onError and
 * the absence of any query invalidation.
 */
export default function usePostNotificationEngagementMutation() {
  const { mutate } = useMutation({
    mutationFn: (payload: TNotificationEngagementPayload) => postNotificationEngagementAPI(payload),
    onError: () => {},
  })

  return { mutate }
}
